module.exports = __webpack_public_path__ + "img/booking-closed-selected.1eb52a6e.svg";